import { AbstractControl, Validators } from '@angular/forms';
import { map, merge, Observable, startWith, tap } from 'rxjs';

export function requireTogether(
  controls: AbstractControl<string | null>[],
): Observable<boolean> {
  return merge(...controls.map((control) => control.valueChanges)).pipe(
    startWith(null),
    map(() => controls.some((control) => !!control.value?.trim())),
    tap((isRequired) =>
      controls.forEach((control) => {
        if (isRequired) {
          control.addValidators(Validators.required);
        } else {
          control.removeValidators(Validators.required);
        }
        control.updateValueAndValidity({ emitEvent: false });
      }),
    ),
  );
}
